import { render, staticRenderFns } from "./mailSide.vue?vue&type=template&id=47162fb2&scoped=true&"
import script from "./mailSide.vue?vue&type=script&lang=js&"
export * from "./mailSide.vue?vue&type=script&lang=js&"
import style0 from "./mailSide.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mailSide.vue?vue&type=style&index=1&id=47162fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47162fb2",
  null
  
)

export default component.exports